import Swiper from 'swiper';

export function tagSwiper() {
    setTimeout(() => {
        document.querySelectorAll('.js-tagSwiper').forEach($content => {
            let $wrapper = $content.querySelector('.swiper-wrapper');
            let $arrows  = $content.querySelector('.swiper-arrows');
            let diff     = $wrapper.clientWidth - $wrapper.scrollWidth;
            let $left    = $arrows.querySelector('.left');
            let $right   = $arrows.querySelector('.right');
            let move     = function (offset = 300) {
                let translate = +$wrapper.style.transform.replace(/[^-\d]/ig, '') + offset;

                // ignore left side
                if (translate > 0) {
                    translate = 0;
                }

                // ignore right side
                if ($wrapper.clientWidth - translate > $wrapper.scrollWidth) {
                    translate += $wrapper.clientWidth - translate - $wrapper.scrollWidth - 30;
                }

                $wrapper.style.transform = `translateX(${translate}px)`;
            }
            console.log($wrapper.clientWidth, $wrapper.scrollWidth)
            if (diff < 0) {
                $content.classList.add('with-arrows');

                $left.addEventListener('click', (e) => {
                    move();
                });

                $right.addEventListener('click', (e) => {
                    move(-300);
                });
            }
        });
    }, 500);
}
